<template>
  <div class="main">
    <FormWrapper :action="formAction" :method="formMethod">
      <div class="title-bar">
        <h1 class="mb-0">{{ brand.id ? "Edit" : "Add New" }} Brand</h1>
        <a class="btn-back" :href="route('admin.brands.index')">
          <span class="icon icon-arrow-left"></span>
          <span class="text">Back to List</span>
        </a>
      </div>
      <div class="row no-gutters py-4">
        <div class="col-12 col-lg-8 col-xl-9">
          <div class="row no-gutters pl-4">
            <div class="col-12">
              <transition name="fade">
                <Alert v-if="hasAlert" :alert="alert" />
              </transition>
            </div>
            <div class="col-12 pb-4 col-lg-4 pr-lg-4">
              <Field type="text" name="name" label="Name" validate="required" :value="brand.name" />
            </div>
            <div class="col-12 pb-4 col-lg-4 pr-lg-4">
              <Field
                type="text"
                name="meta[browser_name]"
                label="Name as it appears in browser windows"
                validate="required"
                validate-as="name as it appears in browser windows"
                :value="brand.meta_values.browser_name"
              />
            </div>
            <div class="col-12 pb-4 col-lg-4">
              <Field
                type="text"
                name="meta[certificate_name]"
                label="Name as it appears on certificates"
                validate="required"
                validate-as="name as it appears on certificates"
                :value="brand.meta_values.certificate_name"
              />
            </div>
            <div class="col-12 pb-4 col-lg-4 pr-lg-4">
              <Field
                type="text"
                name="meta[contact_email]"
                label="Contact Email"
                :value="brand.meta_values.contact_email"
              />
            </div>
            <div class="col-12 pb-4 col-lg-4 pr-lg-4">
              <Field
                type="text"
                name="meta[contact_phone]"
                label="Contact Phone Number"
                :value="brand.meta_values.contact_phone"
              />
            </div>
            <div class="d-none col-4 d-lg-flex"></div>
            <div class="col-12 pb-4 col-lg-4 pr-lg-4">
              <Field
                type="select"
                name="theme_id"
                label="Theme"
                validate="required"
                validate-as="theme"
                :value="brand.theme_id"
                :options="themes"
                :hideSelectEmptyOption="true"
              />
            </div>
            <div class="d-none col-8 d-lg-flex"></div>
            <div class="col-12 pb-4 col-lg-4 pr-lg-4">
              <AssetField
                name="images[logo]"
                label="Logo/Toggle Image"
                help-text="Must be a 150x56 PNG file"
                validate="required"
                validate-as="logo/toggle image"
                :value="brand.image_ids.logo"
                :types="['image']"
              />
            </div>
            <div class="col-12 pb-4 col-lg-4 pr-lg-4">
              <AssetField
                name="images[email]"
                label="Email Image"
                help-text="JPG preferred. Dimensions may vary (Recommended Height: 60px)."
                validate="required"
                validate-as="email image"
                :value="brand.image_ids.email"
                :types="['image']"
              />
            </div>
            <div class="col-12 pb-4 col-lg-4 pr-lg-4">
              <AssetField
                name="images[favicon]"
                label="Browser Shortcut Icon"
                help-text="Must be a square PNG file. Dimensions may vary."
                validate="required"
                validate-as="browser shortcut icon"
                :value="brand.image_ids.favicon"
                :types="['image']"
              />
            </div>
            <div class="col-12 pb-4 col-lg-4 pr-lg-4">
              <AssetField
                name="images[certificate]"
                label="Course/Event Certificate Image"
                help-text="Must be a 2420x1870 JPG file."
                validate="required"
                validate-as="course/event certificate image"
                :value="brand.image_ids.certificate"
                :types="['image']"
              />
            </div>
            <div class="col-12 pb-4 col-lg-4 pr-lg-4">
              <AssetField
                name="images[learning_path]"
                label="Learning Path Certificate Image"
                help-text="Must be a 2420x1870 JPG file."
                validate="required"
                validate-as="learning path certificate image"
                :value="brand.image_ids.learning_path"
                :types="['image']"
              />
            </div>
            <div class="d-none col-4 d-lg-flex"></div>
            <div class="col-12 pb-4 col-lg-4">
              <Field
                type="text"
                name="meta[brightcove_player]"
                label="Brightcove Player ID"
                :value="brand.meta_values.brightcove_player"
              />
            </div>
            <div class="d-none col-8 d-lg-flex"></div>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-3 form-button-wrapper">
          <div class="sticky-top">
            <div class="text-center">
              <button type="submit" class="btn btn-success mr-2">Save Changes</button>
              <a class="btn btn-secondary" :href="route('admin.brands.index')">Cancel & Exit</a>
            </div>
            <div v-if="brand.id" class="font-size-sm text-center pt-4">
              <span>Last updated on {{ brand.updated_at | moment("MM/DD/YYYY") }}</span>
              <span>at {{ brand.updated_at | moment("h:mma") }}</span>
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
  mixins: [DisplaysAlerts],
  props: {
    brand: { type: Object, required: true },
    themes: { type: Array, required: true },
  },
  computed: {
    formAction() {
      return !this.brand.id
        ? this.route("admin.brands.store")
        : this.route("admin.brands.update", {
            brand: this.brand.id,
          });
    },
    formMethod() {
      return !this.brand.id ? "POST" : "PUT";
    },
  },
};
</script>